import React from 'react';
import { fmtDateTime } from '../../utils/helpers';
import { Spinner } from '../../components/ui';
import UserForm from './UserForm';

// Desktop UI for Users — table.
export default function UsersDesktop({ vm }) {
  const { isAdmin, canAddUsers, event, members, loading, modal, roleOf, roleChip, openAdd, openEdit, clearDevice, canResetDevice, deviceInfo, canRemove, remove, isActive, canToggleActive, toggleActive } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Members</h1>
        <span className="muted">{members.length}</span>
        <div className="spacer" />
        {canAddUsers && <button className="btn primary" onClick={openAdd}>+ Add Member</button>}
      </div>
      <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
        {isAdmin
          ? <>Manage who can access <strong>{event?.EventName || 'the selected event'}</strong> and what they can do.</>
          : <>Add members who can sign in and add guests. You can remove the ones you added.</>}
      </div>

      <div className="card table-wrap">
        {loading ? <Spinner /> : members.length === 0 ? <div className="empty">No members yet.</div> : (
          <table className="tbl">
            <thead><tr><th>Name</th><th>Mobile</th><th>Role</th><th>Designation</th><th>Device</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {members.map(row => {
                const role = roleOf(row);
                return (
                  <tr key={row.UserId} className={isAdmin && row.SuperAdmin !== 1 ? 'row-link' : undefined}
                    title={isAdmin && row.SuperAdmin !== 1 ? 'Open permissions' : undefined}
                    onClick={isAdmin && row.SuperAdmin !== 1 ? () => openEdit(row) : undefined}>
                    <td>{`${row.Surname || ''} ${row.Name || ''}`.trim() || '—'}</td>
                    <td>{row.MobileNumber || '—'}</td>
                    <td><span className={roleChip(role)}>{role}</span></td>
                    <td>{row.Designation || '—'}</td>
                    <td>{(() => { const d = deviceInfo(row); return d.bound
                      ? <span title={[row.MobileDeviceId, row.DeviceName].filter(Boolean).join(' / ')}>
                          <span className="chip ok">{d.label}</span>
                          {(d.model || d.since) && <div className="muted" style={{ fontSize: 11.5, marginTop: 2 }}>{d.model}{d.since ? ` · ${fmtDateTime(d.since)}` : ''}</div>}
                        </span>
                      : <span className="chip pend">Not bound</span>; })()}</td>
                    <td>{isActive(row) ? <span className="chip ok">Active</span> : <span className="chip danger">Inactive</span>}</td>
                    <td style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                      {isAdmin && <button className="btn light sm" disabled={row.SuperAdmin === 1} onClick={() => openEdit(row)}>Permissions</button>}
                      {canResetDevice(row) && <button className="btn light sm" style={{ marginLeft: 6 }} title="Super Admin: unbind phone + browser" onClick={() => clearDevice(row)}>Reset Device</button>}
                      {canToggleActive(row) && <button className="btn light sm" style={{ marginLeft: 6 }} onClick={() => toggleActive(row)}>{isActive(row) ? 'Deactivate' : 'Activate'}</button>}
                      {canRemove(row) && <button className="btn danger sm" style={{ marginLeft: 6 }} onClick={() => remove(row)}>Remove</button>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {modal && <UserForm vm={vm} />}
    </div>
  );
}
